import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined, RollbackOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatDateTime } from "utils/formatter";

const LeaveTable = ({
  isLoading = false,
  modalType = "view",
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onView = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
  isEmployee = false,
  isHistory = false
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
  }

  const showActionBar = isEmployee
    ? roles.includes("ACCESS_EMPLOYEE|DOCUMENT|LEAVE")
    : (!isHistory &&
      (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|LEAVE") ||
        roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|LEAVE")));

  function readMode(status, record) {
    let items = []
    if (String(status)?.toLowerCase?.() == 'Draft'?.toLowerCase?.()) {
      if (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|LEAVE") && !isEmployee) {
        items.push({
          key: "1",
          onClick: () => onEdit(record),
          label: `${t("action.edit")}`,
          icon: (
            <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
      if (roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|LEAVE") && !isEmployee) {
        items.push({
          key: "2",
          onClick: () => onDelete(record),
          label: `${t("action.delete")}`,
          icon: (
            <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
    }
    if ((roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST") && !isEmployee) || (isEmployee && roles.includes("ACCESS_EMPLOYEE|DOCUMENT|LEAVE"))) {
      items.push({
        key: "3",
        onClick: () => onView(record),
        label: `${t("action.view")}`,
        icon: (
          <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
        ),
      },)
    }
    if ((roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST") || (isEmployee && roles.includes("ACCESS_EMPLOYEE|DOCUMENT|LEAVE"))) && record?.["approveStatusEn"] == 'Approved' && record?.rejectFlow == null) {
      items.push({
        key: "4",
        onClick: () => onView(record, "reject"),
        label: `${t("common.reject")}`,
        icon: (
          <RollbackOutlined style={{ fontSize: "18px", color: "gray" }} />
        ),
      },)
    }
    return items || []
  }

  const columns = [
    {
      title: <div className="text-table">{t("workin_location.label.reqid")}</div>,
      dataIndex: "sequence",
      key: "sequence",
      align: "center"
    },
    isHistory && {
      title: <div className="text-table">{t("leave_type.label.approvalSequence")}</div>,
      dataIndex: "sequenceNumber",
      key: "sequenceNumber",
      render: (_, record, index) => {
        const getApprovalOrder = () => {
          let order = 1;
          if (record.children === null) {
            order = 1;
          } else if (record.children === undefined) {
            order = index + 2;
          } else {
            order = 1;
          }
          return `${t("leave_type.label.approvalNumber")} ${order}`;
        };

        return getApprovalOrder();
      },
    },
    {
      title: <div className="text-table" >{t("leave_type.entity")}</div>,
      dataIndex: "leaveType",
      key: "leaveType",
      render: (text, record) => {
        let language = i18n.language == 'en' ? "En" : ""
        return text?.["leaveTypeName" + language]
      },
      align: "center"
    },
    {
      title: <div className="text-table">{t("leave_type.label.create_date")}</div>,
      dataIndex: "createDate",
      key: "createDate",
      render: (_, record) => {
        return record?.createDate ? formatDate(record?.createDate) : "-"
      },
      align: "center"
    },
    // {
    //   title: <div className="text-table">{t("name-surname")}</div>,
    //   dataIndex: "fullName",
    //   key: "fullName",
    //   render: (text, record) => {
    //     let language = i18n.language == 'en' ? "En" : ""
    //     return record?.employee?.["nameAndSurname" + language]
    //   }
    // },
    {
      title: <div className="text-table" >{t("leave_type.label.start_date")}</div>,
      dataIndex: "leaveDate",
      key: "leaveDate",
      render: (_, record) => {
        return record?.leaveDate ? formatDate(record?.leaveDate) : "-"
      },
      align: "center"
    },
    {
      title: <div className="text-table">{t("leave_type.label.end_date")}</div>,
      dataIndex: "endDate",
      key: "endDate",
      render: (_, record) => {
        return record?.endDate ? formatDate(record?.endDate) : "-"
      },
      align: "center"
    },
    {
      title: <div className="text-table" >{t("leave_type.label.start-time")}</div>,
      dataIndex: !isHistory ? "leaveDateTime" : "leaveDateTimeString",
      key: !isHistory ? "leaveDateTime" : "leaveDateTimeString",
      // render: (_, record) => {
      //   return record?.leaveDate ? formatDate(record?.startTime) : "-"
      // },
      align: "center"
    },
    {
      title: <div className="text-table">{t("leave_type.label.end-time")}</div>,
      dataIndex: !isHistory ? "endDateTime" : "endDateTimeString",
      key: !isHistory ? "endDateTime" : "endDateTimeString",
      // render: (_, record) => {
      //   return record?.endDate ? formatDate(record?.endTime) : "-"
      // },
      align: "center"
    },
    {
      title: <div className="text-table" >{t("leave_type.label.duration")}</div>,
      dataIndex: "duration",
      key: "duration",
      render: (_, record) => {
        if (record?.durationType === "ALLDAY") {
          return record?.totalDuration + " " + t("unit.days");
        }
        else if (record?.durationType === "HOUR") {
          return (record?.totalDurationHour + " " + t("unit.hours"))
            + " " + (record?.totalDurationMinute + " " + t("unit.minutes"))
        } else return ""
      },
      align: "center"
    },
    {
      title: <div className="text-table" >{t("levave_type_action")}</div>,
      dataIndex: "description",
      key: "description",
      align: "center"
    },
    isHistory && {
      title: <div className="text-table">{t('request_all.approver')}</div>,
      dataIndex: "approverBy",
      key: "approverBy",
      align: "center",
      render: (_, record) => {
        if (record?.approverBy?.nameAndSurname !== null && record?.approverBy?.nameAndSurnameEn !== null) {
          return i18n.language === 'en' ? record?.approverBy?.nameAndSurnameEn : record?.approverBy?.nameAndSurname
        } else if (record?.approverBy?.name !== null && record?.approverBy?.nameEn) {
          return i18n.language === 'en' ? record?.approverBy?.nameEn : record?.approverBy?.name
        }
        return "-"
      }
    },
    isHistory && {
      title: <div className="text-table">{t('leave_type.label.approvalDate')}</div>,
      dataIndex: "approverDate",
      key: "approverDate",
      align: "center",
      render: (_, record) => {
        return record?.approverDate ? formatDateTime(record?.approverDate) : "-"
      }
    },
    {
      title: <div className="text-table" >{t("leave_type.label.leave_status")}</div>,
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        let language = i18n.language == 'en' ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />
      },
      align: "center"
    },
    // !isHistory && (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|LEAVE") || roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|LEAVE") ? actionBar() : {})
    showActionBar ? actionBar() : {}
  ].filter(Boolean);

  function actionBar() {
    if (!isEmployee || roles.includes("ACCESS_EMPLOYEE|DOCUMENT|LEAVE")) {
      return {
        key: "action",
        align: "center",
        width: 60,
        render: (_, record) => {
          // console.log("record", record); // Simplified logging for clarity

          // Ensure readMode always returns a valid array
          const items = readMode(_.approveStatusEn, record) || [];

          return (
            <Space size="middle">
              <Dropdown
                menu={
                  { items }
                }
                trigger={["click"]} // Trigger the dropdown on click
              >
                <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
              </Dropdown>
            </Space>
          );
        },
      };
    } else {
      return {}
    }
  }

  const processedDataSource = dataSource.map(item => {
    if (Array.isArray(item.children) && item.children.length === 0) {
      return { ...item, children: null };
    }
    return item;
  });

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={processedDataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default LeaveTable;
